export default __webpack_public_path__ + "static/5-notifications-935f0dbf7dfdf702941dad79f2e29538.png";